import { cn } from "@/utils";
import type { HTMLAttributes, ReactNode } from "react";

type HermesBadgeProps = HTMLAttributes<HTMLSpanElement> & {
  tone?:
    | "neutral"
    | "accent"
    | "positive"
    | "negative"
    | "warning"
    | "info"
    | "sky";
  /** Ícone antes do texto (o selo continua com texto: o ícone e a cor só reforçam). */
  icon?: ReactNode;
};

const TONE = {
  neutral: "bg-hermes-muted text-hermes-muted-fg",
  accent: "bg-hermes-accent-soft text-hermes-accent",
  positive: "bg-hermes-positive/10 text-hermes-positive",
  negative: "bg-hermes-negative/10 text-hermes-negative",
  warning: "bg-hermes-warning/10 text-hermes-warning",
  info: "bg-hermes-info/15 text-hermes-info",
  sky: "bg-hermes-sky/10 text-hermes-sky",
} as const;

/** Selo de estado: sempre com texto (cor é só reforço). */
export const HermesBadge = ({
  tone = "neutral",
  icon,
  className,
  children,
  ...props
}: HermesBadgeProps) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-xs font-medium whitespace-nowrap tabular-nums",
      TONE[tone],
      className
    )}
    {...props}
  >
    {icon ? (
      <span
        aria-hidden="true"
        className="grid shrink-0 place-items-center [&_svg]:size-3"
      >
        {icon}
      </span>
    ) : null}
    {children}
  </span>
);
